import { Phone, Mail, Clock } from "lucide-react";
import { CONTACT, REGULAMIN_URL } from "../content";
import Reveal from "./Reveal";

export default function Footer() {
  return (
    <footer id="kontakt" className="bg-[#FAF8FC]">
      <div className="airmail-edge" aria-hidden="true" />
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20">
        <div className="grid items-center gap-10 md:grid-cols-[auto_1fr]">
          <Reveal>
            <img
              src={CONTACT.photo}
              alt="Ewa Siereńska — kontakt w sprawie kursu"
              loading="lazy"
              width="768"
              height="768"
              className="mx-auto w-52 rounded-3xl border border-[#EAE6F0] bg-white object-cover shadow-lg shadow-[#242344]/5 sm:w-64"
            />
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="text-2xl font-bold tracking-tight text-[#242344] sm:text-3xl">Kontakt</h2>
            <p className="mt-4 text-lg font-semibold text-[#34343F]">
              Masz pytania?
              <br />
              Chcesz zostać naszym partnerem?
            </p>
            <p className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-[#242344]">
              <Clock size={16} className="text-[#FF008B]" aria-hidden="true" />
              {CONTACT.hours}
            </p>
            <p className="mt-5 text-xl font-extrabold text-[#242344]">{CONTACT.name}</p>
            <div className="mt-3 flex flex-col gap-2.5">
              <a
                href={CONTACT.phoneHref}
                data-testid="contact-phone-link"
                className="inline-flex w-fit items-center gap-2.5 text-lg font-bold text-[#FF008B] transition-colors duration-200 hover:text-[#D90077]"
              >
                <Phone size={19} aria-hidden="true" />
                {CONTACT.phone}
              </a>
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="contact-email-link"
                className="inline-flex w-fit items-center gap-2.5 text-base font-semibold text-[#242344] underline decoration-[#FFB3DA] underline-offset-4 transition-colors duration-200 hover:text-[#FF008B]"
              >
                <Mail size={18} aria-hidden="true" />
                {CONTACT.email}
              </a>
            </div>
          </Reveal>
        </div>
      </div>
      <div className="border-t border-[#EAE6F0] bg-white">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-4 py-5 sm:px-6">
          <img
            src="/assets/edunation-logo.png"
            alt="eduNation"
            className="h-7 w-auto"
            loading="lazy"
          />
          <a
            href={REGULAMIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-regulamin-link"
            className="text-sm font-semibold text-[#68677A] transition-colors duration-200 hover:text-[#FF008B]"
          >
            Regulamin
          </a>
        </div>
      </div>
    </footer>
  );
}
